// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_qq-0";